import React from 'react'
import PropTypes from 'prop-types'
import {SCHEMA_PLP} from '../../../constants'

const SCRIPT_ID = 'plp-structured-data'

const getItemListElements = (products) => {
    return products.map((item, index) => ({
        '@type': SCHEMA_PLP.itemListElementType,
        position: index + 1,
        url: item.slugUrl || item.c_pdpLinks?.[0]?.url
    }))
}

const Schema = ({products}) => {
    if (!products?.length) {
        return null
    }

    const schema = {
        '@context': SCHEMA_PLP.context,
        '@type': SCHEMA_PLP.type,
        itemListElement: getItemListElements(products)
    }

    // Render in the React tree (not Helmet). Helmet keys scripts by innerHTML, so when
    // the product batch grows 12 → 24 it appends a second ItemList instead of replacing.
    return (
        <script
            id={SCRIPT_ID}
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(schema).split('<').join('\\u003c')
            }}
        />
    )
}

Schema.propTypes = {
    products: PropTypes.array
}

export default Schema
